import { NeedHelpIcon } from "@repo/ui/components/shared/SMBIcons";
import { ChevronRight } from "lucide-react";
import USBLink from "@usb-shield/react-link";
import React from "react";
import {
  DISPLAY_PHONE_NUMBER,
  SUPPORT_AVAILABLE_TEXT,
  SUPPORT_PHONE_NUMBER,
  SUPPORT_RELAY_TEXT,
  USE_COBROWSE_SUBTEXT,
  USE_COBROWSE_TEXT,
} from "../../constants/support.constants";

// Extend the Window interface to include Cobrowse
declare global {
  interface Window {
    Cobrowse?: {
      glanceClickEvent_CB?: (
        e: React.MouseEvent<HTMLAnchorElement, MouseEvent>
      ) => void;
      [key: string]: any;
    };
  }
}
interface AemData {
support?: {
    label: string;
    supportHeader: string;
    supportHeaderBody: string;
    cobrowseHeader: string;
    cobrowseText: string; 
},
};
const SupportMenu: React.FC<{ locale?: string,aemData?: AemData }> = ({ locale = "en-us", aemData }) => {
  const showCobrowseOption = locale === "en-us";
  const handleOnCobrowseClick = (
    e: React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ) => {
    if (
      window.Cobrowse &&
      typeof window.Cobrowse.glanceClickEvent_CB === "function"
    ) {
      window.Cobrowse.glanceClickEvent_CB(e);
    }
  };
  const stripHtmlTags = (text: string) => text.replace(/<[^>]*>/g, "");
  const propertyNames = ["callText", "supportPhoneNumber", "supportAvailableText", "supportRelayText"];
  const parsedSupportHeaderBody = aemData?.support?.supportHeaderBody
    ? aemData.support.supportHeaderBody.split("\n").reduce(
        (acc, line, index) => {
          if (propertyNames[index]) {
            acc[propertyNames[index]] = stripHtmlTags(line);
          }
          return acc;
        },
        {} as Record<string, string>
      )
    : null;
  return (
    <div className="pl-[36px] pr-[56px] pb-[30px] lg:py-[30px] lg:px-[22px] sm:px-[36px] sm:pr-[50px] sm:pb-[54px] bg-white">
      <div className="flex items-center gap-2">
        <NeedHelpIcon />
        <h2 className="font-medium">{aemData?.support?.supportHeader ?? "Need help?"}</h2>
      </div>
      <div className="bg-white">
        <div className="flex flex-col items-start gap-1 p-4">
          <USBLink
            className="flex items-center justify-between w-full !text-[#235AE4] !no-underline"
            to={`tel:${parsedSupportHeaderBody?.supportPhoneNumber|| SUPPORT_PHONE_NUMBER}`}
            size="small"
            href={`tel:${parsedSupportHeaderBody?.supportPhoneNumber|| SUPPORT_PHONE_NUMBER}`}
          >
            <span className="font-medium text-[#235AE4]">
              {`${parsedSupportHeaderBody?.callText || "Call"} ${parsedSupportHeaderBody?.supportPhoneNumber || DISPLAY_PHONE_NUMBER}`}
            </span>

            <ChevronRight />
          </USBLink>
          <div className="text-sm  text-[#4C4C50]">
            {parsedSupportHeaderBody?.supportAvailableText || SUPPORT_AVAILABLE_TEXT}
          </div>
          <div className="text-sm  text-[#4C4C50]">{parsedSupportHeaderBody?.supportRelayText || SUPPORT_RELAY_TEXT}</div>
        </div>
        {showCobrowseOption && (
          <div
            style={{ paddingLeft: "16px", margin: "10px 0" }}
            className="flex align-end"
          >
            <div className="w-full h-[1px] bg-border" />
          </div>
        )}
        {showCobrowseOption && (
          <div className="flex flex-col items-start gap-1 p-4">
            <USBLink
              className="flex items-center justify-between w-full !text-[#235AE4] !no-underline text-sm"
              id="cobrowseDesktop"
              size="small"
              href="javascript:;"
            onPress={handleOnCobrowseClick}
          >
            <span className="font-medium text-[#235AE4]">
              {aemData?.support?.cobrowseHeader ?? USE_COBROWSE_TEXT}
            </span>
            <ChevronRight />
          </USBLink>
           <span className="font-[400] text-[#4C4C50] text-[14px]">
              {aemData?.support?.cobrowseText ?? USE_COBROWSE_SUBTEXT}
            </span>
        </div>)}
      </div>
    </div>
  );
};

export default SupportMenu;
